import { Id } from "PFTypes";
import { StateCreator } from "zustand";

import { BookingEditModeStore, SplitModeActions, SplitModeSlice } from "../booking_edit_mode_store.types";
import { getInitialSplitModeState } from "../constants";

export const createSplitModeSlice: StateCreator<
  BookingEditModeStore,
  [],
  [],
  { splitMode: SplitModeSlice }
> = () => ({
  splitMode: getInitialSplitModeState()
});

export const createSplitModeActions = (
  set: (fn: (state: BookingEditModeStore) => void | Partial<BookingEditModeStore>) => void
): SplitModeActions => ({
  addBookingIds: (ids: Id[]) => {
    set((state) => {
      ids.forEach((id) => state.splitMode.bookingIds.add(id));
    });
  },

  splitBooking: (bookingId: Id, splitDate: string) => {
    set((state) => {
      state.splitMode.operationsHistory.push({ bookingId, splitDate });
    });
  },

  undoLastSplit: () => {
    set((state) => {
      state.splitMode.operationsHistory.pop();
    });
  },

  setIsLoading: (value: boolean) => {
    set((state) => {
      state.splitMode.isLoading = value;
    });
  },

  setIsSubmitting: (value: boolean) => {
    set((state) => {
      state.splitMode.isSubmitting = value;
    });
  },

  reset: () => {
    set((state) => {
      state.splitMode = getInitialSplitModeState();
    });
  }
});
